/* ROK Wellness — Theme JavaScript */
(function() {
  'use strict';

  /* === SCROLL PROGRESS === */
  var progressBar = document.getElementById('scrollProgress');
  if (progressBar) {
    window.addEventListener('scroll', function() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0) progressBar.style.transform = 'scaleX(' + (window.scrollY / h) + ')';
    }, { passive: true });
  }

  /* === NAV SCROLL STATE === */
  var rokNav = document.getElementById('rokNav');
  if (rokNav) {
    window.addEventListener('scroll', function() {
      rokNav.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* === MOBILE NAV TOGGLE === */
  var rokBurger = document.getElementById('rokBurger');
  var rokMobileNav = document.getElementById('rokMobileNav');
  var rokNavOpen = false;

  if (rokBurger && rokMobileNav) {
    function rokToggleNav() {
      rokNavOpen = !rokNavOpen;
      rokBurger.classList.toggle('active', rokNavOpen);
      rokBurger.setAttribute('aria-expanded', rokNavOpen);
      rokBurger.setAttribute('aria-label', rokNavOpen ? 'Close menu' : 'Open menu');
      rokMobileNav.classList.toggle('active', rokNavOpen);
      document.body.style.overflow = rokNavOpen ? 'hidden' : '';
    }
    rokBurger.addEventListener('click', rokToggleNav);
    document.querySelectorAll('.mobile-nav-link').forEach(function(link) {
      link.addEventListener('click', function() { if (rokNavOpen) rokToggleNav(); });
    });
  }

  /* === FAQ ACCORDION === */
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = btn.closest('.faq-item');
      var answer = item.querySelector('.faq-answer');
      var isOpen = item.classList.contains('active');

      /* Close other open items */
      document.querySelectorAll('.faq-item.active').forEach(function(open) {
        if (open !== item) {
          open.classList.remove('active');
          open.querySelector('.faq-answer').style.maxHeight = '0';
          open.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
        }
      });

      if (isOpen) {
        item.classList.remove('active');
        answer.style.maxHeight = '0';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('active');
        answer.style.maxHeight = answer.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* === SCROLL REVEALS === */
  var revealEls = document.querySelectorAll('.reveal, .reveal-scale');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
    revealEls.forEach(function(el) { revealObs.observe(el); });
  }

  /* === COUNTER ANIMATION === */
  var counters = document.querySelectorAll('[data-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var counterObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-count'));
        var isDecimal = el.hasAttribute('data-decimal');
        var start = performance.now();
        var duration = 2000;

        function update(now) {
          var progress = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 4);
          var val = eased * target;

          if (isDecimal) {
            el.textContent = val.toFixed(1);
          } else {
            el.textContent = Math.floor(val).toLocaleString() + '+';
          }

          if (progress < 1) requestAnimationFrame(update);
        }
        requestAnimationFrame(update);
        counterObs.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(function(el) { counterObs.observe(el); });
  }

  /* === MOBILE STICKY BARS: appear only after scrolling ~20% down the page
     (keeps the main hero CTA clear above the fold) === */
  function rokScrollSticky(el) {
    if (!el) return;
    function update() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? (window.scrollY / max) : 0;
      el.classList.toggle('visible', pct >= 0.2);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  rokScrollSticky(document.getElementById('rokMobileSticky'));

  /* === HERO PARALLAX === */
  var heroImage = document.querySelector('.hero-image');
  if (heroImage && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    window.addEventListener('scroll', function() {
      if (window.scrollY < window.innerHeight) {
        heroImage.style.transform = 'translateY(' + (window.scrollY * 0.15) + 'px) scale(1.05)';
      }
    }, { passive: true });
  }

  /* === PDP: Gallery Thumbnails === */
  var galleryMainImg = document.getElementById('gallery-active');
  var galleryThumbs = document.querySelectorAll('.gallery-thumb');
  var galleryIndex = 0;

  if (galleryMainImg && galleryThumbs.length) {
    galleryThumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() {
        galleryThumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        galleryIndex = i;
        var fullSrc = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
        galleryMainImg.style.opacity = '0';
        setTimeout(function() {
          galleryMainImg.src = fullSrc;
          galleryMainImg.style.opacity = '1';
        }, 200);
      });
    });

    /* Gallery prev/next buttons */
    var prevBtn = document.getElementById('gallery-prev');
    var nextBtn = document.getElementById('gallery-next');

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        galleryIndex = (galleryIndex - 1 + galleryThumbs.length) % galleryThumbs.length;
        galleryThumbs[galleryIndex].click();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        galleryIndex = (galleryIndex + 1) % galleryThumbs.length;
        galleryThumbs[galleryIndex].click();
      });
    }
  }

  /* === PDP: Size Swatch Selector === */
  document.querySelectorAll('.size-swatch[data-variant-id]').forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      document.querySelectorAll('.size-swatch').forEach(function(s) { s.classList.remove('active'); });
      swatch.classList.add('active');
      var variantId = swatch.getAttribute('data-variant-id');
      if (variantId) {
        var url = new URL(window.location);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url);
        /* Update hidden variant input */
        var hiddenInput = document.querySelector('input[name="id"]');
        if (hiddenInput) hiddenInput.value = variantId;
        /* Dispatch change event */
        document.dispatchEvent(new CustomEvent('rok:variant-change', { detail: { variantId: variantId } }));
      }
    });
  });

  /* === PDP: Addon Toggle === */
  var addonToggle = document.getElementById('addon-outdoor');
  if (addonToggle) {
    addonToggle.addEventListener('click', function() {
      addonToggle.classList.toggle('active');
      var isActive = addonToggle.classList.contains('active');
      addonToggle.setAttribute('aria-checked', isActive);
    });
    addonToggle.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        addonToggle.click();
      }
    });
  }

  /* === PDP: Add to Cart (adds the add-on variant too when checked) === */
  var pdpForm = document.getElementById('rok-pdp-form');
  if (pdpForm) {
    pdpForm.addEventListener('submit', function(e) {
      var addon = document.getElementById('addon-outdoor');
      var addonVariant = (addon && addon.classList.contains('active'))
        ? (addon.getAttribute('data-variant-id') || '').trim() : '';
      // No add-on selected (or none configured) -> let the form submit the main product normally.
      if (!addonVariant) return;

      e.preventDefault();
      var mainIdEl = pdpForm.querySelector('[name="id"]');
      var items = [];
      if (mainIdEl && mainIdEl.value) items.push({ id: parseInt(mainIdEl.value, 10), quantity: 1 });
      items.push({ id: parseInt(addonVariant, 10), quantity: 1 });

      var btn = document.getElementById('btn-cart');
      if (btn) btn.setAttribute('disabled', 'disabled');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
        .then(function(res) {
          if (!res.ok) { throw new Error((res.data && res.data.description) || 'add failed'); }
          window.location.href = '/cart';
        })
        .catch(function() {
          // Never block the customer: fall back to a normal add of the main product.
          if (btn) btn.removeAttribute('disabled');
          pdpForm.submit();
        });
    });
  }

  /* === PDP: Sticky Mobile Bar (appears after ~20% scroll) === */
  rokScrollSticky(document.getElementById('rokPdpSticky'));
  // Sticky bar's Add to Cart routes through the main form (so the add-on logic runs too)
  var stickyAdd = document.getElementById('rok-sticky-add');
  var mainCartBtn = document.getElementById('btn-cart');
  if (stickyAdd && mainCartBtn) {
    stickyAdd.addEventListener('click', function() { mainCartBtn.click(); });
  }
  // Sticky bar model selector: jump to the chosen sauna's product page
  var stickySelect = document.getElementById('rok-sticky-select');
  if (stickySelect) {
    stickySelect.addEventListener('change', function() {
      if (stickySelect.value) window.location.href = stickySelect.value;
    });
  }

})();
